export const formatPrice = (v, currency = "EUR", lang = "fr") => {
  if (v == null || v === "") return null;
  return new Intl.NumberFormat(lang === "fr" ? "fr-FR" : "en-GB", { style: "currency", currency, maximumFractionDigits: 0 }).format(v);
};

export const formatKm = (v, lang = "fr") => (v == null ? "" : `${new Intl.NumberFormat(lang === "fr" ? "fr-FR" : "en-GB").format(v)} km`);

export const STATUS_COLORS = {
  available: "#10b981",
  reserved: "#e2c89d",
  sold: "#8b95a5",
  off_market: "#6b7280",
  coming_soon: "#60a5fa",
};

export const vehicleTitle = (v) => [v.make, v.model].filter(Boolean).join(" ");

export const coverOf = (v) => {
  const img = v.images?.[v.cover_index] || v.images?.[0];
  return { full: img?.url || "", thumb: img?.thumb || img?.url || "", alt: img?.alt || vehicleTitle(v) };
};

export const COUNTRIES = ["France", "Monaco", "Switzerland", "Germany", "Italy", "Belgium", "Netherlands", "United Kingdom", "Spain", "United Arab Emirates"];
export const COUNTRIES_FR = { France: "France", Monaco: "Monaco", Switzerland: "Suisse", Germany: "Allemagne", Italy: "Italie", Belgium: "Belgique", Netherlands: "Pays-Bas", "United Kingdom": "Royaume-Uni", Spain: "Espagne", "United Arab Emirates": "Émirats arabes unis" };
